/*! dependencies: cash */
instant.qbrick = {
  status: {
  },
  init: function () {
    instant.qbrick.addCookieInformationEvents();
  },
  bindEvents: function () {
    cash('body').on('click', '.media--qbrick', function () {
      if (Cookiebot.consent.statistics !== true && Cookiebot.consent.preferences !== true) {
        alert(instant.settings.youMustGiveCookieConsent);
        Cookiebot.renew();
      } else {
        var video = cash(this);
        instant.qbrick.startVideo(video);
      }
    });
  },
  startVideo: function (mediaEle) {
    var playButton = mediaEle.find('.qplayer__play-btn')[0];
    if(playButton) {
      mediaEle.find('.video-overlay').remove();
      playButton.click();
    }
  },
  addCookieInformationEvents: function () {
    window.addEventListener('CookiebotOnConsentReady', function () {
      window.killInteractivePlayer && window.killInteractivePlayer();
      var videoElements = Array.from(document.querySelectorAll('[data-qplayer-media-id]'));
      var scenarioElements = Array.from(document.querySelectorAll('[data-qplayer-scenario-id]'));
      var analyticsValue = Cookiebot && Cookiebot.consent.statistics ? 'on' : 'off';

      videoElements.map(function(el) {
        el.innerHTML = '';
        el.setAttribute('data-qplayer-analytics', analyticsValue);
      });
      
      scenarioElements.map(function(el) {
        el.innerHTML = '';
        el.setAttribute('data-qplayer-analytics', analyticsValue);
      });

      window.initiateInteractivePlayer && window.initiateInteractivePlayer();
    }, false);
    
    instant.qbrick.bindEvents();
  }
}